import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import template from 'hbars!templates/meMenu';
import NotificationsCollection from 'models/NotificationsCollection';
import NotificationsView from 'views/NotificationsView';
import TutorialView from 'views/TutorialView';
import {
    parse as parseQueryString,
    stringify as stringifyQueryString
} from 'query-string';
import Auth from 'models/Auth';

var MeMenuView = Backbone.View.extend({
    events: {
        'click .me-menu-leave-community': 'leaveCommunityClicked',
        'click .me-menu-sign-out': 'signOutClicked',
        'click .me-menu-notifications': 'notificationsClicked',
        'click .me-menu-invite': 'inviteFriends'
    },

    initialize: function(options) {
        this.event = Global.get('event');
        this.listenTo(
            this.model,
            'change:unread-count',
            this.changeUnreadCounter
        );
        this.listenTo(this.model, 'change:firstName', this.render);
        this.listenTo(this.model, 'change:lastName', this.render);
        this.listenTo(this.model, 'change:photoSet', this.render);
        this.listenTo(this.model, 'change:isJoined', this.joinChanged);
        this.listenTo(Backbone, 'invite-friends', this.inviteFriends);
        this.startFetchingBadge();
        this.notificationsCollection = new NotificationsCollection();
        this.notificationsCollection._meta.event = this.event;
        this.notificationsView = new NotificationsView({
            model: this.notificationsCollection,
            el: this.$('.notifications-list')
        });
        this.isCommunityEnabled = options?.isCommunityEnabled;
        this.isPeopleV2Community = this.event.get('features')?.communityVersion === 'PEOPLE_V2';
    },

    handleProfileImageError: function() {
        const extractAvatarId = (num, mod) => {
            num = num !== undefined ? num : 0;
            return (num % mod) + 1;
        };
        const userId = this.model.get('id');
        const fixBrokenSrc = event =>
            (event.target.src = `/images/community/avatars/avatar_${extractAvatarId(
                userId,
                4
            )}.png`);
        this.$el
            .find('.me-menu-show-dropdown img.me-menu-photo')
            .on('error', fixBrokenSrc);
    },

    notificationsClicked: function() {
        var thisView = this;
        this.notificationsCollection.fetch({
            success: function() {
                thisView.notificationsCollection.markAsRead();
            }
        });
    },

    joinChanged: function() {
        this.$el.toggleClass('hide', !this.model.get('isJoined'));
        if (this.model.get('isJoined')) {
            this.startFetchingBadge();
        }
        this.render();
    },

    startFetchingBadge: function() {
        this.model.get('isJoined') &&
            this.model.fetchUnreadCount(this.event.id);
    },
    /**
     * PM decided to stop showing tutorial, because it's out of date
     */
    // tutorialClicked: function() {
    //     var tutorial = new TutorialView();
    //     tutorial.render();
    // },

    leaveCommunityClicked: function() {
        var success = function() {
            var url = Global.get('event').getPublicWebsiteBaseUrl();
            if (Global.get('isWidget')) {
                url = `${Global.get('event').getCommunityUrl()}?widget=true`;
            }
            _.delay(function() {
                window.location = url;
            }, 100);
        };
        this.model.leave(this.event.id, {
            success: success
        });
    },

    signOutClicked: async function() {
        const thisView = this;
        const auth = new Auth();
        await auth.signOut();
        thisView.signedOut();
    },

    getSignOutUrl: function() {
        const event = Global.get('event');
        const isWidget = Global.get('isWidget');
        if (isWidget) {
            const { url: hostUrl } = parseQueryString(document.location.search);
            const params = {
                widget: 'true',
                url: hostUrl
            };
            return `${this.event.getInternalWebsiteBaseUrl('/community')}?${stringifyQueryString(
                params
            )}`;
        } else {
            return event.getPublicWebsiteBaseUrl();
        }
    },

    signedOut: function() {
        window.location = this.getSignOutUrl();
    },

    changeUnreadCounter: function() {
        if (this.model && this.model.get('unread-count')) {
            var notifications =
                this.model.get('unread-count').notifications || 0;
            var messages = this.model.get('unread-count').messages || 0;
            if (notifications > 0) {
                this.$('.me-messages-badge.notifications').toggleClass(
                    'hide',
                    false
                );
            } else {
                this.$('.me-messages-badge.notifications').toggleClass(
                    'hide',
                    true
                );
            }
            if (messages > 0) {
                this.$('.me-messages-badge.messages').toggleClass(
                    'hide',
                    false
                );
            } else {
                this.$('.me-messages-badge.messages').toggleClass('hide', true);
            }
        }
    },

    inviteFriends: function() {
        var source = {
            me: this.model.toJSON(),
            event: this.event.toJSON()
        };
        var subject = '{{me.first-name}} invites you to join {{{event.name}}}';
        var body = [
            'Hi,\n\n',
            'I plan to go to {{{event.name}}} and I thought you might be interested to attend as well. It should be a great event.\n\n',
            'You can learn more about the event and its attendees here: {{event.landing-page-url}}\n\n',
            'I hope to see you there,\n\n',
            'Cheers,\n',
            '{{me.first-name}} {{me.last-name}}'
        ].join('');
        var url =
            'mailto:?subject=' +
            encodeURIComponent(Handlebars.compile(subject)(source)) +
            '&body=' +
            encodeURIComponent(Handlebars.compile(body)(source));
        window.open(url);
    },

    render: function() {
        var html = template({
            me: this.model.toJSON(),
            event: this.event.toJSON(),
            isWidget: Global.get('isWidget'),
            isCommunityEnabled: this.isCommunityEnabled,
            isPeopleV2Community: this.isPeopleV2Community,
        });
        this.$el.html(html);
        this.notificationsView.setElement(this.$('.notifications-list'));
        this.changeUnreadCounter();
        this.handleProfileImageError();
        return this;
    }
});

export default MeMenuView;
